module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uOShGo/images/Cover.jpg?1737821500432",
      "alt": "This image is the cover for the book 12 Days of Mardi Gras"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("12 Days of Mardi Gras\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Repetition, alliteration, and visual humor abound in this Mardi Gras themed riff on the iconic holiday song, perfect for emerging readers and early counters. As each day of the Mardi Gras season passes, a gift is given. Each of the many, many, many gifts is familiar to those who embrace the season's traditions. Coming in twos, twelves, fives and fours, the gifts include majestic masks, floats a rolling, golden shoes, and cherished cups. Colorful illustrations provide lots of additional hijinks and engagement in this soon-to-be-classic holiday tale!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Melissa Thibault, Nichole Dupre\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("As an elementary school counselor, art teacher, and school librarian, Melissa Thibault has spent over 15 years reveling in children's literature. She earned a Bachelor's degree in elementary education and a Master's specializing in School Counseling from Louisiana State University.  While working as a school counselor, Thibault incorporated many books in her programs. She attained her School Library Certification and now spreads her own magic as an author. Inspired by her students, Thibault hopes to instill a love of reading in each child she meets. She spends her time in Louisiana with her charismatic daughter and their trouble-making beagle, Nola.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pelican Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0